import React from 'react';
import * as stylex from '@stylexjs/stylex';
import '../theme/Colors.stylex';
import { ColorNeutral } from '../theme/Colors.stylex';
import { Title } from '../typography/Title';
import '../theme/Spaces.stylex';
import { Gap, Padding } from '../theme/Spaces.stylex';
import '../theme/Fonts.stylex';
import { FontFamily, FontSize, LineHeight } from '../theme/Fonts.stylex';
import '../theme/Radius.stylex';
import { CornerRadius } from '../theme/Radius.stylex';

// MARK: root
// ==========
type Props = {
  title: string;
  commentSvg?: React.ReactNode;
  comment?: string;
  commentColor?: string;
  actionElements?: React.ReactNode;
};
function Component({
  title,
  commentSvg,
  comment,
  commentColor,
  actionElements
}: Props) {
  return <div className="display-x78zum5 alignItems-x6s0dn4 justifyContent-x1qughib width-xh8yej3 minHeight-xbktkl8 padding-xb4tss4 gap-x2u8dy9 backgroundColor-x12peec7 borderStyle-x1y0btm7 borderWidth-xmkeg23 borderColor-x8u4suw borderRadius-x1qd5jr3" data-style-src="wino-gc:src/resources/layout-and-structure/CanaryToolbarDocument.tsx:50">
      <div className="display-x78zum5 flexDirection-xdt5ytf alignSelf-x1y8v6su justifyContent-xl56j7k minHeight-x21xpn4 flex-x98rzlu" data-style-src="wino-gc:src/resources/layout-and-structure/CanaryToolbarDocument.tsx:64">
        <Title level={5} weight="semibold" color={ColorNeutral.textAccent}>
          {title}
        </Title>
        <span {...stylex.props(styles.presentationComment, styles.presentationCommentFromProps(commentColor ?? null))}>
          {commentSvg}
          {comment}
        </span>
      </div>
      <div className="display-x78zum5 alignSelf-xamitd3 alignItems-x6s0dn4 gap-xqcaodp" data-style-src="wino-gc:src/resources/layout-and-structure/CanaryToolbarDocument.tsx:84">{actionElements}</div>
    </div>;
}
const MemoizedComponent = React.memo(Component);
export { MemoizedComponent as ToolbarDocument };
export type { Props };

// MARK: styles
// ============
const styles = {
  presentationComment: {
    "display-k1xSpc": "display-x3nfvp2",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "gap-kOIVth": "gap-xgolt85",
    "fontFamily-kMv6JI": "fontFamily-x111x8ze",
    "fontSize-kGuDYH": "fontSize-x1egw0ox",
    "lineHeight-kLWn49": "lineHeight-x7mozim",
    "color-kMwMTN": "color-xt4ixol",
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryToolbarDocument.tsx:72"
  },
  presentationCommentFromProps: (color: string | null) => [{
    "color-kMwMTN": (color ?? null) != null ? "color-x14rh7hd" : color ?? null,
    $$css: "wino-gc:src/resources/layout-and-structure/CanaryToolbarDocument.tsx:81"
  }, {
    "--x-color": (color ?? null) != null ? color ?? null : undefined
  }]
};